/**
 * Comprime imagens no lado do cliente antes do upload.
 * Usa Canvas API para redimensionar e comprimir.
 */

const compressImage = (file, options = {}) => {
  const { maxSizeKB = 200, maxWidth = 1200, maxHeight = 1200, quality = 0.7 } = options;

  return new Promise((resolve, reject) => {
    if (!file.type?.startsWith('image/')) {
      resolve(file);
      return;
    }

    const img = new Image();
    const reader = new FileReader();

    img.onerror = () => {
      console.warn('[compressImage] Erro ao carregar imagem, enviando original:', file.name);
      resolve(file);
    };

    reader.onload = (e) => {
      img.src = e.target.result;
    };

    reader.onerror = () => {
      console.warn('[compressImage] Erro ao ler arquivo, enviando original:', file.name);
      resolve(file);
    };

    img.onload = () => {
      let { width, height } = img;

      // Redimensionar mantendo proporção
      if (width > maxWidth) {
        height = Math.round((height * maxWidth) / width);
        width = maxWidth;
      }
      if (height > maxHeight) {
        width = Math.round((width * maxHeight) / height);
        height = maxHeight;
      }

      const canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0, width, height);

      // Tentar comprimir iterativamente até atingir o tamanho alvo
      let currentQuality = quality;
      const targetBytes = maxSizeKB * 1024;

      const tryCompress = () => {
        const dataUrl = canvas.toDataURL('image/webp', currentQuality);
        const bytes = Math.round((dataUrl.length - 'data:image/webp;base64,'.length) * 0.75);

        if (bytes <= targetBytes || currentQuality <= 0.05) {
          // Converter dataURL para File
          const arr = dataUrl.split(',');
          const mimeMatch = arr[0].match(/:(.*?);/);
          const mime = mimeMatch ? mimeMatch[1] : 'image/webp';
          const bstr = atob(arr[1]);
          const u8arr = new Uint8Array(bstr.length);
          for (let i = 0; i < bstr.length; i++) u8arr[i] = bstr.charCodeAt(i);

          const ext = file.name.replace(/\.[^.]+$/, '') + '.webp';
          const compressed = new File([u8arr], ext, { type: mime });
          console.log('[compressImage]', file.name, file.size, '→', compressed.size, 'bytes, qualidade:', currentQuality.toFixed(1));
          resolve(compressed);
          return;
        }

        currentQuality -= 0.1;
        tryCompress();
      };

      tryCompress();
    };

    reader.readAsDataURL(file);
  });
};

export default compressImage;
